<ng-container>
  <div class="clients-publish-selector" [ngClass]="{ focus: focus }">
    <gl-input
      [id]="id + '-resume'"
      [title]="question.placeholder | translate"
      type="text"
      [icon]="question.editable && !question.disabled ? 'glicon-edit' : ''"
      [skeletorValueAccessor]="question"
      [placeholder]="question.placeholder | translate"
      [label]="question.label | translate"
      [options]="question.options"
      [value]="resume"
      [selector]="question.selector"
      [attr.mandatory]="question.validators?.required ? true : null"
      [attr.disabled]="question.disabled ? true : null"
      readonly
      (onClick)="onEdit()"
    >
    </gl-input>
  </div>
</ng-container>

<lms-modal #modalClientsPublishSelector size="small">
  <lms-dynamic-form
    [questions]="questions"
    [options]="{ showSpinnerUponSubmitting: false, submitLabel: 'actions.accept', disableCard: true }"
    (submit)="onSave($event)"
  >
    <gl-button
      color-secondary
      [text]="'actions.cancel' | translate"
      (onClick)="modalClientsPublishSelector.close()"
      form-actions-before
    ></gl-button>
  </lms-dynamic-form>
</lms-modal>

<!-- Confirm course publish change modal -->
<lms-modal #modalConfirmPublishModeChange>
  <div class="gl-popup__title gap-bottom">{{ 'courses.publishChange.confirm.title' | translate }}</div>
  <div class="gl-popup__close" (click)="onCancelSave()">
    <span class="glicon-close"></span>
  </div>

  <div class="gl-popup__text">{{ 'courses.publishChange.confirm.affectedItineraries' | translate }}</div>
  <div class="gl-popup__text">
    <div *ngFor="let itinerary of affectedItineraries">
      - {{ itinerary.name + (itinerary.clientName ? ' (' + itinerary.clientName + ')' : '') }}
    </div>
  </div>

  <div class="gl-popup__text">{{ 'courses.publishChange.confirm.description' | translate }}</div>

  <div class="gl-popup__buttons position-static padding-top__big">
    <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="onCancelSave()"> </gl-button>
    <gl-button color-primary [text]="'actions.removeAccess' | translate" (onClick)="onConfirm()"></gl-button>
  </div>
</lms-modal>
